import { useAuth, useUserData } from '@conteg/auth';
import { CUSTOM_AUTH_TOKEN, IS_KIOSK } from 'config';
import { useToken } from 'utils/device-auth/device-auth-store';

export const useUserIdProvider = (): boolean => {
  const { user } = useAuth();
  const tokenOnKiosk = useToken();

  const tokenToParse = IS_KIOSK
    ? tokenOnKiosk
    : CUSTOM_AUTH_TOKEN || user?.access_token;

  const userData = useUserData(tokenToParse);

  return !!userData?.isProvider;
};
